"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiple = void 0;
exports.multiple = [
    {
        patientMrn: "10604190847",
        dateOfService: 1654041600000,
        providerNumber: "163168",
        uniqueDocumentNumber: "",
        placerOrderNumber: "987574857",
        fillerOrderNumber: "E13470862",
        encounterNumber: "",
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "RADIOLOGY",
        documentCategory: "HL7",
        messageCategory: null,
        documentStatus: "FINAL",
        documentName: "oru1.txt",
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 8592,
        externalId: "1445878",
        documentGuid: {
            uuid: "5fe81075-7bb3-48a8-b848-1b92b42b0301"
        },
        documentId: 18083850,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: null,
        additionalInfo: null,
        hl7MessageDirection: null,
        hl7MessageType: null,
        id: 18089850,
        specialty: ""
    },
    {
        patientMrn: "10604190847",
        dateOfService: 1654041600000,
        providerNumber: "1608358",
        uniqueDocumentNumber: "",
        placerOrderNumber: "987574857",
        fillerOrderNumber: "E13470862",
        encounterNumber: "3437628293-2022-06-01-16316",
        encounterGuid: {
            uuid: "dc611288-0f75-45e0-90e6-2c5ce5184da4"
        },
        observationRequestGuid: {
            uuid: "b9f4cbb3-e51d-40e8-b19f-a13d67dd0400"
        },
        observationResultGuid: {
            uuid: "6be2b133-97f5-4369-a734-d3d17fa3119b"
        },
        documentType: "RADIOLOGY",
        documentCategory: "NOTE",
        messageCategory: null,
        documentStatus: "FINAL",
        documentName: null,
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 1707,
        externalId: "1445878",
        documentGuid: {
            uuid: "d9ad4d72-3ed0-4355-a20c-62dfbb6dbe1a"
        },
        documentId: 18131394,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: null,
        additionalInfo: null,
        hl7MessageDirection: null,
        hl7MessageType: null,
        id: 18131294,
        specialty: ""
    }
];
//# sourceMappingURL=radiology.js.map